import { styled } from '@mui/material';

const StyledDataDisplay = styled('div', {
  name: 'StyledDataDisplay',
  slot: 'root',
})(({ theme }) => ({
  width: '100%',

  '& .label': {
    color: (theme.vars || theme).palette.inputLabel,
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.75rem',
    letterSpacing: ' 0.00938em',
    padding: 0,
    display: 'block',
    transformOrigin: 'top left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(133 % -32px)',
    position: 'absolute',
    left: 0,
    top: 0,
    transform: 'translate(14px, -9px) scale(0.75)',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    zIndex: 1,
    pointerEvents: 'auto',
    userSelect: 'none',
  },
  '& fieldset': {
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: '-5px',
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderStyle: 'solid',
    borderWidth: '1px',
    overflow: 'hidden',
    minWidth: '0%',
    borderColor: (theme.vars || theme).palette.borderColor,
    borderRadius: '4px',
    '& legend': {
      float: 'unset',
      width: 'auto',
      overflow: 'hidden',
      display: 'block',
      padding: 0,
      height: '11px',
      fontSize: '1rem',
      visibility: 'hidden',
      maxWidth: '100%',
      webkitTransition: 'max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms',
      transition: 'max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms',
      whiteSpace: 'nowrap',

      '& span': {
        paddingLeft: '5px',
        paddingRight: '5px',
        display: 'inline-block',
        opacity: 0,
        visibility: 'visible',
      },
    },
  },

  '& .data-display-contents': {
    whiteSpace: 'nowrap',
    display: 'flex',
    flex: 5,
    flexDirection: 'row',
    minHeight: '1.75rem',
    justifyContent: 'space-between',
    alignContent: 'center',
    overflowX: 'auto',
    borderRadius: `${theme.shape.borderRadius}px`,

    '& .action': {
      padding: '8.5px !important',
      overflow: 'visible',
    },
  },
}));
export default StyledDataDisplay;
